<script setup lang="ts">
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
</script>

<template>
  <div>
    <Toast position="top-center" />
    <RouterView />
  </div>
</template>
